import React from 'react';
import { Link } from 'react-router-dom';
import '../components/Aurora.css';
import Aurora from './Aurora';

function NotFound() {
  return (
    <div className="aurora-container">
      <Aurora
        colorStops={["#3A29FF", "#ACADBC", "#006A52"]}
        blend={0.5}
        amplitude={1.0}
        speed={0.5}
      />
      <div className="container" style={{ 
        textAlign: 'center', 
        padding: '100px 20px',
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '16px',
          padding: '60px 40px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(12px)',
          maxWidth: '500px',
          width: '100%'
        }}>
          <div style={{ 
            fontSize: '6rem', 
            marginBottom: '20px',
            opacity: 0.8
          }}>
            🔬
          </div>
          
          <h1 style={{ 
            color: 'var(--white)', 
            fontSize: '3rem', 
            marginBottom: '20px',
            fontWeight: '600'
          }}>
            404
          </h1>
          
          <h2 style={{ 
            color: 'rgba(255, 255, 255, 0.8)', 
            fontSize: '1.5rem', 
            marginBottom: '30px',
            fontWeight: '400'
          }}>
            Page Not Found
          </h2>
          
          <p style={{ 
            color: 'rgba(255, 255, 255, 0.7)', 
            fontSize: '1.1rem', 
            marginBottom: '40px',
            lineHeight: '1.6'
          }}>
            The page you're looking for seems to have wandered off into the lab. 
            Let's get you back to familiar territory.
          </p>
          
          <Link 
            to="/" 
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              background: 'rgba(72, 187, 120, 0.2)',
              border: '2px solid rgba(72, 187, 120, 0.4)',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '1.1rem',
              fontWeight: '500',
              transition: 'all 0.3s ease',
              backdropFilter: 'blur(8px)'
            }}
            onMouseOver={(e) => {
              e.target.style.background = 'rgba(72, 187, 120, 0.3)';
              e.target.style.borderColor = 'rgba(72, 187, 120, 0.6)';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.target.style.background = 'rgba(72, 187, 120, 0.2)';
              e.target.style.borderColor = 'rgba(72, 187, 120, 0.4)';
              e.target.style.transform = 'translateY(0px)';
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9,22 9,12 15,12 15,22"/>
            </svg>
            Return to Home
          </Link>
          
          <div style={{ 
            marginTop: '30px',
            fontSize: '0.9rem',
            color: 'rgba(255, 255, 255, 0.5)'
          }}>
            Or use the navigation menu above to explore our research
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
